var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29167 10C1.29167 5.89519 1.29167 3.84185 2.56675 2.56677C3.84183 1.29169 5.89425 1.29169 10 1.29169C14.1048 1.29169 16.1582 1.29169 17.4332 2.56677C18.7083 3.84185 18.7083 5.89427 18.7083 10C18.7083 14.1049 18.7083 16.1582 17.4332 17.4333C16.1582 18.7084 14.1058 18.7084 10 18.7084C5.89517 18.7084 3.84183 18.7084 2.56675 17.4333C1.29167 16.1582 1.29167 14.1058 1.29167 10Z",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 6.79169C8.16667 6.42701 8.0218 6.07728 7.76394 5.81942C7.50608 5.56155 7.15634 5.41669 6.79167 5.41669C6.427 5.41669 6.07726 5.56155 5.8194 5.81942C5.56153 6.07728 5.41667 6.42701 5.41667 6.79169C5.41667 7.15636 5.56153 7.5061 5.8194 7.76396C6.07726 8.02182 6.427 8.16669 6.79167 8.16669C7.15634 8.16669 7.50608 8.02182 7.76394 7.76396C8.0218 7.5061 8.16667 7.15636 8.16667 6.79169ZM8.16667 6.79169H14.5833M11.8333 13.2084C11.8333 12.8437 11.9782 12.4939 12.2361 12.2361C12.4939 11.9782 12.8437 11.8334 13.2083 11.8334C13.573 11.8334 13.9227 11.9782 14.1806 12.2361C14.4385 12.4939 14.5833 12.8437 14.5833 13.2084C14.5833 13.573 14.4385 13.9228 14.1806 14.1806C13.9227 14.4385 13.573 14.5834 13.2083 14.5834C12.8437 14.5834 12.4939 14.4385 12.2361 14.1806C11.9782 13.9228 11.8333 13.573 11.8333 13.2084ZM11.8333 13.2084H5.41667",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2982bcbf0323c9217f6f685b3f6e52f7.svg";
export { ForwardRef as ReactComponent };